/**
 * @generated SignedSource<<86ca30f7064858544621af61f7d22e17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CampaignPrType = "product_offer" | "rewarded";
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "tiktok_go" | "twitter" | "youtube";
import { FragmentRefs } from "relay-runtime";
export type Apply$data = {
  readonly askingPrice: number | null;
  readonly id: string;
  readonly parentMediaType: ParentMediaType;
  readonly prType: CampaignPrType | null;
  readonly " $fragmentSpreads": FragmentRefs<"ApplyCampaign" | "ApplyConfirmation" | "ApplyProduct" | "ApplyReward">;
  readonly " $fragmentType": "Apply";
};
export type Apply$key = {
  readonly " $data"?: Apply$data;
  readonly " $fragmentSpreads": FragmentRefs<"Apply">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Apply",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentMediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "askingPrice",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyCampaign"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyReward"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyProduct"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyConfirmation"
    }
  ],
  "type": "Campaign",
  "abstractKey": null
};

(node as any).hash = "0f1ef4064f7489d966278b9ea70927a8";

export default node;
